/*
 * Constants to represent the status of a Renovation Plan.
 */
const RENOVATION_STATUS = {
    planning: 'planning',
    submitted: 'submitted',
    abandoned: 'abandoned',
    complete: 'completed',
    updating: 'updating',
}

export default RENOVATION_STATUS
